/** Roles that are not scheduled operationally (Verwaltung, SuperAdmin). */
const BACK_OFFICE_ROLES = new Set(['verwaltung', 'superadmin']);

export function isBackOfficeRole(role: string | null | undefined): boolean {
  return BACK_OFFICE_ROLES.has((role ?? '').toLowerCase());
}
